export function subtractDays(date, days) {
  const dateCopy = new Date(date)
  dateCopy.setDate(dateCopy.getDate() - days)
  return dateCopy
}
export function addDays(date, days) {
  const dateCopy = new Date(date)
  dateCopy.setDate(dateCopy.getDate() + days)
  return dateCopy
}
export function subtractMonths(date, months) {
  const dateCopy = new Date(date)
  dateCopy.setMonth(dateCopy.getMonth() - months)
  return dateCopy
}
export function addMonths(date, months) {
  const dateCopy = new Date(date)
  dateCopy.setMonth(dateCopy.getMonth() + months)
  return dateCopy
}
export function subtractYears(date, years) {
  const dateCopy = new Date(date)
  dateCopy.setFullYear(dateCopy.getFullYear() - years)
  return dateCopy
}
export function getLastDateOfMonth(year, month) {
  return new Date(year, month + 1, 0)
}
export function getFirstDateOfMonth(year, month) {
  return new Date(year, month, 1)
}
export function getLastDateOfYear(year) {
  return new Date(year, 12, 0)
}
export function getFirstDateOfYear(year) {
  return new Date(year, 0, 1)
}
export function getDaysDiff(date1, date2) {
  const diffTime = Math.abs(date2 - date1)
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
  return diffDays
}
export function getYearsDiff(date1, date2) {
  return Math.abs(date2.getFullYear() - date1.getFullYear())
}
export function getYearsDiffWithSign(date1, date2) {
  return date2.getFullYear() - date1.getFullYear()
}
export function getMonthsDiff(date1, date2) {
  return Math.abs(
    (date2.getFullYear() - date1.getFullYear()) * 12 -
      date1.getMonth() +
      date2.getMonth()
  )
}
export function getMonthsDiffWithSign(date1, date2) {
  let months = 0
  months = (date2.getFullYear() - date1.getFullYear()) * 12
  months -= date1.getMonth()
  months += date2.getMonth()
  return months
}
export function getDaysInMonth(year, month) {
  return new Date(year, month, 0).getDate()
}
export function getDateFromThaiTimezone() {
  const currentDateTime = new Date(
    new Date().toLocaleString('en-US', { timeZone: 'Asia/Bangkok' })
  )
  let now = new Date(currentDateTime)
  now.setHours(0, 0, 0, 0)
  return now
}
export function getEndOfDateFromThaiTimezone() {
  const currentDateTime = new Date(
    new Date().toLocaleString('en-US', { timeZone: 'Asia/Bangkok' })
  )
  let now = new Date(currentDateTime)
  now.setHours(23, 59, 59, 999)
  return now
}
export function getDateWithThaiTimezoneFromDate(date, startHour = 'start') {
  const currentDateTime = new Date(
    new Date(date).toLocaleString('en-US', { timeZone: 'Asia/Bangkok' })
  )
  let now = new Date(currentDateTime)
  if (startHour === 'start') {
    now.setHours(0, 0, 0, 0)
  } else {
    now.setHours(23, 59, 59, 999)
  }
  return now
}

export function isSameDay(dateString1, dateString2) {
  let date1 = new Date(dateString1)
  let date2 = new Date(dateString2)

  if (isNaN(date1) || isNaN(date2)) {
    return false
  }

  return (
    date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate()
  )
}

export function getDateFromDateAndTime(dateString, timeString) {
  // Split the date and time strings
  const dateParts = dateString.split('-')
  const timeParts = timeString.split(':')

  // Extract year, month, day, hour, and minute from the split parts
  const year = parseInt(dateParts[0])
  const month = parseInt(dateParts[1]) - 1 // Months are zero-based (0-11)
  const day = parseInt(dateParts[2])
  const hour = parseInt(timeParts[0])
  const minute = parseInt(timeParts[1])

  // Create a new Date object with the extracted values
  const combinedDate = new Date(year, month, day, hour, minute)
  return combinedDate
}
